/**
 * Default Theme Sound Configuration
 *
 * Minimal sounds for the default board - only line clear and finisher.
 * Uses the blaster sound for both.
 */

import blasterSoundPath from '../../../../assets/sounds/blaster.mp3';
import fallSoundPath from '../../../../assets/sounds/fall.wav';
import rotateBlockSoundPath from '../../../../assets/sounds/rotateBlock.wav';

export const DEFAULT_SOUND_CONFIG = {
  name: 'Default',
  description: 'Default board sounds - blaster for line clears/finisher, fall for hard drop',

  sounds: {
    lineClear: {
      src: blasterSoundPath,
      volume: 0.5,
      rate: 1.0
    },

    finisher: {
      src: blasterSoundPath,
      volume: 0.5,
      rate: 1.0
    },

    hardDrop: {
      src: fallSoundPath,
      volume: 0.5,
      rate: 1.0
    },

    rotateBlock: {
      src: rotateBlockSoundPath,
      volume: 0.5,
      rate: 1.0
    }
  },

  mappings: {
    fall: null,                    // No theme sound for movement
    rotateBlockSound: 'rotateBlock', // Failed rotation → rotateBlock.wav
    whipSound: 'hardDrop',         // Hard drop → fall.wav
    blasterSound: 'lineClear',     // Single line clear → blaster
    deliciousSound: 'finisher'     // Multi-line finisher → blaster
  },

  // Flag to disable score animation for this board
  disableScoreAnimation: true
};

export default DEFAULT_SOUND_CONFIG;
